<template>
<q-list dense separator>
  <q-expansion-item
      switch-toggle-side
      v-for="mapGroup in maps"
      :key="mapGroup.id">
    <template v-slot:header>
      <q-item-section side top>
        <q-checkbox :modelValue="true"
                    @click="removeGroup(mapGroup.maps)"
                    @keyup.space="removeGroup(mapGroup.maps)"
        />
      </q-item-section>
      <q-item-section>
        <q-item-label>{{ mapGroup.title }}</q-item-label>
      </q-item-section>
      <q-item-section side>
        <q-btn round @click.stop="toggleMapGroupVisible(mapGroup)"
               flat
               :aria-label="mapGroup.id === visibleMapGroup ? `Toon huidige selectie`:`Toon de kaart van ${mapGroup.title}`"
        >

          <q-tooltip>
            {{ mapGroup.id === visibleMapGroup ? `Toon huidige selectie` : `Toon de kaart van ${mapGroup.title}` }}
          </q-tooltip>
          <q-icon v-if="visibleMapGroup === mapGroup.id" name="visibility_off" />
          <q-icon v-else name="visibility" />
        </q-btn>
        <count-chip :count="mapGroup.maps.length" />
      </q-item-section>
    </template>
    <q-list dense separator>
      <q-item v-for="map in mapGroup.maps"
              :key="map.id"
              :inset-level="1">
        <q-item-section side top>
          <q-checkbox :modelValue="true"
                      @click="removeMap(map.id)"
                      @keyup.space="removeMap(map.id)"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label>{{ map.title }}</q-item-label>
        </q-item-section>
        <q-item-section side>
          <q-btn round @click.stop="toggleMapVisible(map)"
                 flat
                 :aria-label="map.id === visibleMap ? `Toon huidige selectie`:`Toon de kaart van ${map.title}`"
          >

            <q-tooltip>
              {{ map.id === visibleMap ? `Toon huidige selectie` : `Toon de kaart van ${map.title}` }}
            </q-tooltip>
            <q-icon v-if="visibleMap === map.id" name="visibility_off" />
            <q-icon v-else name="visibility" />
          </q-btn>
        </q-item-section>
      </q-item>
    </q-list>
  </q-expansion-item>
</q-list>
</template>

<script>
export default {
  emits: ['update:modelValue', 'update:visibleMap', 'update:visibleMapGroup'],
  props: {
    maps: {
      required: true,
      type: Array,
    },
    modelValue: {
      required: true,
      type: Array,
    },
    visibleMap: {
      type: Number,
    },
    visibleMapGroup: {
      type: Number,
    },
  },
  methods: {
    removeGroup (maps) {
      const ids = maps.map(map => map.id)
      this.$emit('update:modelValue', this.modelValue.filter(id => !ids.includes(id)))
    },
    removeMap (mapId) {
      this.$emit('update:modelValue', this.modelValue.filter(id => id !== mapId))
    },
    toggleMapGroupVisible (mapGroup) {
      if (this.visibleMap) {
        this.$emit('update:visibleMap', null)
        this.$emit('update:visibleMapGroup', mapGroup.id)
      } else if (this.visibleMapGroup === mapGroup.id) {
        this.$emit('update:visibleMapGroup', null)
      } else {
        this.$emit('update:visibleMapGroup', mapGroup.id)
      }
    },
    toggleMapVisible (mapId) {
      if (this.visibleMapGroup) {
        this.$emit('update:visibleMapGroup', null)
        this.$emit('update:visibleMap', mapId.id)
      } else if (this.visibleMap === mapId.id) {
        this.$emit('update:visibleMap', null)
      } else {
        this.$emit('update:visibleMap', mapId.id)
      }
    },
  },
}
</script>
